const onboarding = {
  languageTitle: 'Odaberite jezik',
  languageDescription: 'Odaberite željeni jezik aplikacije.',
  welcomeTitle: 'Dobro došli u VoiceFill Medical',
  welcomeDescription: 'Optimizirajte medicinsku dokumentaciju uz pomoć AI-a.',
  feature1Title: 'Snimanje glasa',
  feature1Desc: 'Snimajte medicinske izvještaje na siguran način.',
  feature2Title: 'AI Transkripcija',
  feature2Desc: 'Napredni AI pretvara govor u strukturirani tekst.',
  feature3Title: 'Sigurnost i privatnost',
  feature3Desc: 'Vaši podaci su šifrirani i zaštićeni.',
};

export default onboarding;
